export default __webpack_public_path__ + "static/media/insuranceList.89af3075.png";